













import { Component, Prop } from 'nuxt-property-decorator'
import NoneSearchResult from '~/components/experience/none-search-result/none-search-result'

@Component

export default class NoneSearchResultDesktop extends NoneSearchResult {
  @Prop({ default: '/experiences/' }) deepLink!: string
}
